export const PARTICLES_CONTAINER_ID_PREFIX = 'sling-particles-container';
export const THROTTLE_ANIMATION = 3500;
